import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PublicComponent } from './public.component';
import { AutoCompleteModule } from '../shared/autoComplete/autoComplete.module';

@NgModule({
  imports: [
    AutoCompleteModule,
    RouterModule.forChild([
      {
        path: 'public',
        component: PublicComponent,
      },
    ]),
  ],
  exports: [RouterModule],
})
export class PublicRoutingModule {}
